import PageHeader from '@/components/generals/page-header'
import ActiveDot from '@/assets/images/companies/header/active-dot.svg'

export default function CompaniesHeader() {
    return (
        <PageHeader
            title="Companies"
            tabs
            pill={(
                <span className='caption-style bg-muted inline-flex shrink-0 items-center gap-0.5 rounded-full border border-[#363636] py-[3px] pr-[5px] pl-[3px]'>
                    <ActiveDot aria-hidden className='size-3' />
                    Active
                </span>
            )}
        />
    )
}
